module.exports = __webpack_public_path__ + "static/media/by-bmo-logo-fr.5f9eca6b.svg";